/**
 * Shared Google Maps loader configuration.
 *
 * IMPORTANT: useJsApiLoader must be called with IDENTICAL options everywhere
 * in the app, or you get: "Loader must not be called again with different options".
 *
 * Import GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES, and GOOGLE_MAPS_LOADER_ID
 * from this file in every component that calls useJsApiLoader.
 */

export const GOOGLE_MAPS_API_KEY = "AIzaSyDLzC-FhQmB8JS2H46OW46DNOEboBbrZVg";

// Must be a module-level constant (stable reference — never an inline array)
// Must be THE SAME array used by every component in the app
export const GOOGLE_MAPS_LIBRARIES = ["places", "geometry"];

// Single loader ID shared across all components
export const GOOGLE_MAPS_LOADER_ID = "google-maps-shared-loader";